import * as tslib_1 from "tslib";
import { Component, Watch, Mixins } from 'vue-property-decorator';
import Filters from './filters';
import FilterBtn from './components/FilterBtn.vue';
import Result from './components/Result.vue';
import ResultSelected from './components/ResultSelected.vue';
import Help from "./Help";
import * as cpfHelp from './cpf.help';
var Settings = cpfHelp.Settings;
import * as responsiveKey from './responsiveKey';
import Popup from './popup';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import '@trevoreyre/autocomplete-vue/dist/style.css';
import { getSpsCarParks, searchMbResultsAndSpsSites } from '@/help.search';
import "./styles.less";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
const token = 'pk.eyJ1IjoiYmNhbWVyb25zbWl0aCIsImEiOiJjazkydDNreXIwNGcxM2RtdndzM3p0a3Y0In0.Zd_a3O2c52fBSCIt14iQ4g';
const makeSearchLessUseful = false;
const limitCarParksResultsDisplay = 30;
var pmfIcon = L.icon({
    iconRetinaUrl: require('./assets/marker-icon-pmf-2x.png'),
    iconUrl: require('./assets/marker-icon-pmf.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [44, 50],
    iconAnchor: [22, 50],
    popupAnchor: [0, -32]
});
delete pmfIcon._getIconUrl;
var pmIcon = L.icon({
    iconRetinaUrl: require('./assets/marker-icon-pm-2x.png'),
    iconUrl: require('./assets/marker-icon-pm.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [44, 50],
    iconAnchor: [22, 50],
    popupAnchor: [0, -32]
});
delete pmIcon._getIconUrl;
var pmpIcon = L.icon({
    iconRetinaUrl: require('./assets/marker-icon-pmp-2x.png'),
    iconUrl: require('./assets/marker-icon-pmp.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [44, 50],
    iconAnchor: [22, 50],
    popupAnchor: [0, -32]
});
delete pmpIcon._getIconUrl;
var pmppaIcon = L.icon({
    iconRetinaUrl: require('./assets/marker-icon-pmp-pa-2x.png'),
    iconUrl: require('./assets/marker-icon-pmp-pa.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [44, 50],
    iconAnchor: [22, 50],
    popupAnchor: [0, -32]
});
delete pmppaIcon._getIconUrl;
var pmpaIcon = L.icon({
    iconRetinaUrl: require('./assets/marker-icon-pm-pa-2x.png'),
    iconUrl: require('./assets/marker-icon-pm-pa.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [44, 50],
    iconAnchor: [22, 50],
    popupAnchor: [0, -32]
});
delete pmpaIcon._getIconUrl;
var paIcon = L.icon({
    iconRetinaUrl: require('./assets/marker-icon-pa-2x.png'),
    iconUrl: require('./assets/marker-icon-pa.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [44, 50],
    iconAnchor: [22, 50],
    popupAnchor: [0, -32]
});
delete paIcon._getIconUrl;
var amGoIcon = L.icon({
    iconRetinaUrl: require('./assets/marker-icon-am-go-2x.png'),
    iconUrl: require('./assets/marker-icon-am-go.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [44, 50],
    iconAnchor: [22, 50],
    popupAnchor: [0, -32]
});
delete paIcon._getIconUrl; //TODO: Can shadowUrl, iconSize, iconAnchor and popupAnchor be merged into a class to stop repetition of code?
//Now putting a marker with this icon on a map is easy:
//L.marker([51.5, -0.09], { icon: greenIcon }).addTo(map);
const debounce2 = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            timeout = null; // null timeout to indicate the debounce ended
            func(...args); // Execute the callback
        };
        clearTimeout(timeout); // This will reset the waiting every function execution. This is the step that prevents the function from being executed because it will never reach the inside of the previous setTimeout
        timeout = setTimeout(later, wait); // Restart the debounce waiting period.setTimeout returns a truthy value (it differs in web vs Node)
    };
};
import VueDraggableResizable from 'vue-draggable-resizable';
let App = class App extends Mixins(Filters) {
    constructor() {
        super(...arguments);
        this.offScreenObserver = null;
        this.observedElement_SelectedResult = null;
        this.debounceHandler = debounce2(this.doFiltering, 250); //was 450 stop user hammering filtering with normal clicking filters etc / panning map etc
        this.combinedResults = true; ///TODO:TD remove, for debugging totggle between MBApi and both
        this.currentBounds = L.latLngBounds(L.latLng(52.200479, -3.025207), L.latLng(52.202571, -3.021529));
        this.markers = cpfHelp.getEmptyMarkerClusterGroup();
        this.mapLoaded = false;
        this.pinsLoaded = false;
        this.isFiltering = true;
        this.dataLoaded = false;
        this.parentToUnspiderify = null;
        this.selectedMarkerId = 0;
        this.selectedResult = null;
        this.resultsListForDisplayCalcCounts = 0;
        this.initialSearchTerm = "";
        this.autoSelectGeocodeResult = false;
        this.autoSelectedResult = null;
        this.initialId = 0;
        this.areaManagerFilterId = null; // areaManagerFilterId: number = 0;// areaManagerFilterId: number | null = null;
        this.selectedIsSticky = false;
        this.allCarParks = [];
        //these are filtered by filter buttons only
        this.filteredCarParks = [];
        this.filteredCarParksMarkers = [];
        this.resultsList = [];
        this.webSocialShareShown = false;
        this.windowHeight = window.innerHeight;
        this.windowWidth = window.innerWidth;
        this.width = 0;
        this.height = this.mapAndResizerInitialHeight;
        this.x = 0;
        this.y = 0;
    }
    //lifecycles
    created() {
        this.setInitialSearchTerm(); //ronseal
        this.getCarParks(); //finally calls this.setupAllCarParkPins() 
    }
    mounted() {
        this.getMap(); //?? 
        this.setupAllCarParkPins(); //??
        if (!Help.isNullOrEmpty(this.initialSearchTerm)) {
            this.$refs.autocompleteref.$refs.input.focus();
        }
        this.$nextTick(() => {
            window.addEventListener('resize', this.onWindowResize);
        });
    }
    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
        if (this.map) {
            this.map.remove(); //https://stackoverflow.com/questions/42816517/cant-load-leaflet-inside-vue-component
        }
    }
    resultShareClick(id) {
        this.webSocialShareShown = true;
    }
    get resListIsSticky() {
        return this.selectedIsSticky && this.selectedMarkerId > 0;
    }
    resetAll() {
        var newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
        //console.log(`newUrl is ${newUrl}`)
        window.top.location.href = newUrl; // window.location.href = newUrl https://stackoverflow.com/questions/3783639/window-location-href-but-where-the-address-bar-changes
    }
    clearFilters() {
        this.filters.forEach(f => f.selected = false);
    }
    toggleStickTest() {
        this.selectedIsSticky = !this.selectedIsSticky;
    }
    getShareUrl() {
        var host = window.location.protocol + "//" + window.location.host;
        return `${host}/car-park-finder?id=${this.selectedMarkerId}`;
    }
    webShareClosed() {
        this.webSocialShareShown = false;
    }
    selectResult(id) {
        console.log(">> Selecting " + id);
        this.selectedMarkerId = id;
        var mId = this.filteredCarParksMarkers.filter(x => x.id === id)[0];
        if (!mId.marker._icon) {
            console.log(">> Spiderifying parent");
            this.parentToUnspiderify = mId.marker.__parent;
            this.parentToUnspiderify.spiderfy(); //leaves open when closed... we could perhaps zoom instead like zoomToBoundsOnClick ?
        }
        if (Help.isNullOrUndef(mId.marker)) {
            console.log("marker was null could not open poupup");
        }
        mId.marker.openPopup(); //else?
        this.$nextTick(function () {
            if (this.offScreenObserver != null) {
                this.offScreenObserver.disconnect();
            }
            if (!this.resizable) {
                this.observedElement_SelectedResult = document.querySelector('.result_wrap_selected');
                if (!this.offScreenObserver) {
                    this.offScreenObserver = new IntersectionObserver(this.onElementObserved, { threshold: 1, rootMargin: '-50px 0px 0px 0px' });
                }
                if (this.offScreenObserver != null && this.observedElement_SelectedResult != null) {
                    this.offScreenObserver.observe(this.observedElement_SelectedResult);
                }
            }
        });
    }
    toggleSelectedResult(id, fromMarkerClick = false) {
        if (this.selectedMarkerId === id) {
            this.selectedMarkerId = 0;
        }
        else
            this.selectResult(id);
    }
    onElementObserved(entries) {
        entries.forEach(entry => {
            if (entry.intersectionRatio != 1) {
                if (entry.boundingClientRect.top < 50) {
                    this.selectedIsSticky = true;
                }
            }
            else {
                //INTERESTINGLY seems on https://parkmark.co.uk/car-park-finder that 13 results = flicker, 14 or more = no flicker... so perhaps can make results list always a minimum height of 14 ?? 
                //seem to be 80 with bottom margin of 10 so 90 total
                // setTimeout(() => {
                //console.log("selectedIsSticky setting to false")
                this.selectedIsSticky = false;
                // }, 400) //timeout to avoid mad flickering sticky to not and back (seen when filtering to pmf i.e. 11 results, and selecting top)
            }
        });
    }
    isSelected(id) {
        return this.selectedMarkerId === id;
    }
    doFiltering() {
        this.resultsList = this.calcResultsList();
        this.isFiltering = false;
        if (this.initialId > 0 && this.resultsList.length > 0) {
            this.$nextTick(function () {
                try {
                    this.toggleSelectedResult(this.initialId);
                }
                catch (error) {
                    console.log("cp id not found : " + this.initialId);
                }
                this.initialId = 0;
            });
        }
    }
    setupAllCarParkPins() {
        if (!this.pinsLoaded && this.allCarParks.length > 0 && this.mapLoaded) {
            this.setPinsForFilteredCarParks();
            this.map.addLayer(this.markers);
            this.pinsLoaded = true;
            if (this.autoSelectedResult != null) {
                this.autocompleteSubmit(this.autoSelectedResult);
                this.autoSelectedResult = null;
            }
            this.setupResults();
        }
    }
    setPinsForFilteredCarParks() {
        //align this.filteredCarParksMarkers with this.filteredCarParks//add or remove markers as necessary
        var msToRemove = this.filteredCarParksMarkers.filter(x => !this.filteredCpsIds.includes(x.id));
        var markersToRemove = msToRemove.map((x) => x.marker);
        this.markers.removeLayers(markersToRemove);
        msToRemove.forEach((x) => {
            Help.removeItemFromArray(this.filteredCarParksMarkers, x);
        });
        var msToAdd = this.filteredCarParks.filter(x => !this.markersCpsIds.includes(x.id));
        var markersToAdd = [];
        msToAdd.forEach((cp) => {
            try { //TODO:NOW clean ALSO mental... only setting the icon in each scope... SORT
                var marker;
                if (cp.hasPmf) { //TODO:TD this is cheap and nasty, we are pretending that PMF will never have anything else... when actually the cdata (CURRENTLY) is using pm CPs with pmf = true to fake proper PMF data
                    marker = L.marker(cpfHelp.carParkToLocation(cp), { title: cp.name, icon: pmfIcon }); //same in getPinInfo
                }
                else if (cp.hasPmp && !cp.hasPa && cp.hasPm) {
                    marker = L.marker(cpfHelp.carParkToLocation(cp), { title: cp.name, icon: pmpIcon });
                }
                else if (cp.hasPmp && cp.hasPa && cp.hasPm) {
                    marker = L.marker(cpfHelp.carParkToLocation(cp), { title: cp.name, icon: pmppaIcon });
                }
                else if (!cp.hasPmp && cp.hasPa && cp.hasPm) {
                    marker = L.marker(cpfHelp.carParkToLocation(cp), { title: cp.name, icon: pmpaIcon });
                }
                else if (!cp.hasPm && cp.hasPa) {
                    marker = L.marker(cpfHelp.carParkToLocation(cp), { title: cp.name, icon: paIcon });
                }
                else if (cp.hasAmGo) {
                    marker = L.marker(cpfHelp.carParkToLocation(cp), { title: cp.name, icon: amGoIcon });
                }
                else {
                    marker = L.marker(cpfHelp.carParkToLocation(cp), { title: cp.name, icon: pmIcon });
                }
                marker.bindPopup(Popup.createPopup(cp));
                marker.off('click');
                marker.on('click', (a) => {
                    this.toggleSelectedResult(cp.id, true); //TODO:scroll the result in list into view - if it's being shown !!! pass a bool to toggleSelectedResult for "fromMarkerClick"
                });
                this.filteredCarParksMarkers.push({ id: cp.id, marker: marker });
                markersToAdd.push(marker);
            }
            catch (e) {
                console.log(`${cp.id} ${cp.name} ${e}`);
            }
        });
        this.markers.addLayers(markersToAdd);
    }
    calcResultsList() {
        if (this.pinsLoaded) {
            if (this.anyFiltersSelected) {
                this.filteredCarParks = this.allCarParks.filter(x => cpfHelp.containsAllItems(x.filters, this.filtersSelected));
            }
            else {
                this.filteredCarParks = this.allCarParks.slice();
            }
            if (this.areaManagerFilterIdValid)
                this.filteredCarParks = this.filteredCarParks.filter(x => x.areaManagerId == this.areaManagerFilterId);
            let sw = this.currentBounds.getSouthWest();
            let ne = this.currentBounds.getNorthEast();
            return this.filteredCarParks.filter(x => x.latitude <= ne.lat && x.latitude >= sw.lat
                && x.longitude <= ne.lng && x.longitude >= sw.lng);
        }
        return [];
    }
    geoCode(input) {
        return new Promise(resolve => {
            this.autoSelectedResult = null;
            let url = "";
            if (makeSearchLessUseful) {
                url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(input)}.json?access_token=${token}&cachebuster=1593958895616&autocomplete=true&country=gb&types=region,postcode,district,place,locality,neighborhood,address`;
            }
            else {
                url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(input)}.json?access_token=${token}&cachebuster=1593958895616&autocomplete=true&country=gb`;
            }
            if (input.length < 3) {
                return resolve([]);
            }
            else {
                console.log(`Getting Places from MBox for "${input}"...`);
                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                    console.log(`MBox gave us ${data.features.length} results for "${input}"`); //should prob see if can use the place_type address, postcode, place etc and the "bbox" in the results to help choose zoom level?
                    if (this.autoSelectGeocodeResult) {
                        console.log(`autoSelectGeocodeResult`);
                        if (data.features.length > 0) {
                            this.autoSelectedResult = data.features[0];
                        }
                        this.autoSelectGeocodeResult = false;
                    }
                    else
                        console.log(`NOT autoSelectGeocodeResult`);
                    if (this.combinedResults) {
                        var res = searchMbResultsAndSpsSites(data.features, this.filteredCarParks, input);
                        console.log(`SEARCH GOOD`);
                        resolve(res);
                    }
                    else {
                        console.log(data.features.map((r) => r.relevance)); //0-1 https://docs.mapbox.com/api/search/geocoding-v5/#mapboxplaces
                        //var results = data.features.map((r) => toCommonResult(r))
                        //var localSearchRes = searchSpsSites(this.filteredCarParks, input)
                        //var newArr = [...localSearchRes, ...results]
                        //resolve(newArr)
                        resolve([]);
                    }
                });
            }
        });
    }
    getAutocompleteResultValue(result) {
        return result.text;
    }
    autocompleteSubmit(result) {
        if (result.isSps) {
            this.map.once('zoomend', () => {
                setTimeout(() => {
                    console.log("zoomend isSps");
                    this.selectResult(result.id);
                }, 300); //we use a timeout in addition to the leaflet.js event handlers, otherwise seems some timing clash and end up without spiderified and popup
            });
        }
        cpfHelp.flyToResult(result, this.map); //could pass another param here, if from querystring auto search - so can be less zoomed e.g. 14 or so = more results?
    }
    setInitialSearchTerm() {
        let query = this.getUrlParameter('query');
        let cpId = this.getUrlParameter('id');
        let amId = this.getUrlParameter('amId');
        if (!Help.isNullOrEmpty(query)) {
            this.initialSearchTerm = query;
            this.autoSelectGeocodeResult = true;
        }
        else if (!Help.isNullOrEmpty(cpId) && Help.canConvertToNumber(cpId)) {
            var idToSet = parseInt(cpId, 10);
            this.initialId = idToSet;
        }
        else if (!Help.isNullOrEmpty(amId) && Help.canConvertToNumber(amId)) {
            var amIdToSet = parseInt(amId, 10);
            this.areaManagerFilterId = amIdToSet;
        }
    }
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        //console.log("getUrlParameter results " + results);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' ')); //.replace(/\+/g, ' ') replaces + with space
    }
    getCarParks() {
        getSpsCarParks().then(rs => {
            this.allCarParks = rs;
        }).finally(() => {
            this.dataLoaded = true;
            this.setupAllCarParkPins();
        });
    }
    getMap() {
        //this.map = L.map('map_inner', { worldCopyJump: true });
        //TODO:KEY option 2 
        this.map = L.map('map_inner', { worldCopyJump: true, zoomControl: false });
        this.map.setView([Settings.mapDefaultLat, Settings.mapDefaultLng], Settings.mapZoomDefault);
        this.map.options.minZoom = Settings.mapMinZoomLevel;
        this.currentBounds = this.map.getBounds();
        this.map.on('moveend', () => { this.currentBounds = this.map.getBounds(); }); //TODO:our off for results is why map bounds stop working to refliter here
        cpfHelp.setBaseLayers(this.map);
        //TODO:KEY option 2 
        L.control.zoom({
            position: 'topright'
        }).addTo(this.map);
        // (this.map as any)._layersMaxZoom = 19; //https://github.com/Leaflet/Leaflet.markercluster/issues/611
        this.mapLoaded = true;
        responsiveKey.getResponsiveKey(this.map);
        this.setupAllCarParkPins();
    }
    setupResults() {
        this.isFiltering = true;
        this.debounceHandler(); //doFiltering
    }
    onCurrentBoundsChanged(value, oldValue) {
        this.setupResults();
    }
    onFiltersSelectedChanged(value, oldValue) {
        this.setupResults();
    }
    onFilteredCarParksChanged(value, oldValue) {
        var idsNow = value.map((cp) => cp.id);
        var idsOld = oldValue.map((cp) => cp.id);
        let actuallySame = (idsNow == '' + idsOld);
        if (!actuallySame) {
            this.setPinsForFilteredCarParks();
        }
    }
    onWindowResize() {
        this.windowHeight = window.innerHeight;
        this.windowWidth = window.innerWidth;
    }
    onResize(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    onDrag(x, y) {
        this.x = x;
        this.y = y;
    }
    get areaManagerFilterIdValid() {
        return Help.isGoodNumber(this.areaManagerFilterId);
    }
    get resizable() {
        return this.windowWidth < 600; //@narrow: ~ "screen and (max-width: 600px)";
    }
    get searchPlaceholder() {
        if (this.resizable) {
            return "Parking or Place (postcode, address etc)";
        }
        return "Parking or Places (postcode, address etc)";
    }
    get maxHeight() {
        return this.windowHeight - 73;
    }
    get mapAndResizerInitialHeight() {
        return (this.windowHeight - 73) / 2;
    }
    get mapHeight() {
        if (this.resizable) {
            return ((this.windowHeight - 73 - this.height) + 12); // this.mapAndResizerInitialHeight + 10;// (this.windowHeight - 73 - this.height);// + 10; //10 allows map to be taller than should so curved border works
        }
        else {
            return this.windowHeight - 50; //@main_height: calc(100vh - @header_height);
        }
    }
    get filtersHeight() {
        if (!this.filtersExpanded) {
            return "120px";
        }
        else {
            let height_filter_btn_px = 108;
            let width_filters_px = 400;
            if (this.resizable) {
                width_filters_px = this.windowWidth;
            }
            let filters_left_right_pad_total = 10;
            let num_filters_inc_toggle = 15;
            let width_filter_btn_px = 74;
            let number_filters_per_row = (width_filters_px - filters_left_right_pad_total) / width_filter_btn_px;
            let number_rows = Math.ceil(num_filters_inc_toggle / number_filters_per_row);
            let filters_expanded_height = ((number_rows * height_filter_btn_px) + filters_left_right_pad_total);
            return `${filters_expanded_height}px`;
        }
    }
    get filtersWidth() {
        return `${this.filtersWidthInner}px !important`;
    }
    get filtersWidthInner() {
        let width_filters_px = 400;
        if (this.resizable) {
            width_filters_px = this.windowWidth;
        }
        let filters_left_right_pad_total = 10;
        let width_filter_btn_px = 74;
        let number_filters_per_row = Math.floor((width_filters_px - filters_left_right_pad_total) / width_filter_btn_px);
        return (number_filters_per_row * width_filter_btn_px) + filters_left_right_pad_total;
    }
    //computed //computed//computed//computed//computed//computed//computed//computed//computed//computed//computed
    get webSocialShareConfig() {
        let url = this.getShareUrl();
        return {
            displayNames: true,
            config: [{
                    copy: {
                        socialShareUrl: url
                    }
                },
                {
                    email: {
                        socialShareBody: `${url}\r\n\r\n`,
                        socialShareSubject: 'Park Mark accredited Car Park',
                    }
                },
                {
                    facebook: {
                        socialShareUrl: url,
                        socialSharePopupWidth: 400,
                        socialSharePopupHeight: 400 //has loads of options - but not sure they do anything
                    }
                },
                {
                    linkedin: {
                        socialShareUrl: url //socialShareDescription?: string; //socialShareSource?: string;
                    }
                },
                {
                    twitter: {
                        socialShareUrl: url,
                        socialSharePopupWidth: 300,
                        socialSharePopupHeight: 400,
                        socialShareText: `Park Mark accredited Car Park : `,
                        socialShareHashtags: `ParkMark,saferparking` //socialShareVia?: string;
                    }
                },
                {
                    whatsapp: {
                        socialShareUrl: url,
                        socialShareText: 'Park Mark accredited Car Park',
                    }
                }]
        };
    }
    get resultsSubtitle() {
        let amFilterNote = "";
        if (this.areaManagerFilterIdValid) {
            var name = this.filteredCarParks[0].areaManagerFullName;
            amFilterNote = ` - AreaManager ${name}`;
        }
        if (Help.arrayAllEqual([this.resultsList.length, this.filteredCarParks.length, this.allCarParks.length])) {
            return `Showing all ${this.allCarParks.length} car parks${amFilterNote}`;
        }
        else if (Help.arrayAllEqual([this.resultsList.length, this.filteredCarParks.length])) {
            return `${this.resultsList.length} matching filters, ${this.allCarParks.length} Total${amFilterNote}`;
        }
        else if (Help.arrayAllEqual([this.filteredCarParks.length, this.allCarParks.length])) {
            return `${this.resultsList.length} mapped, ${this.allCarParks.length} Total${amFilterNote}`;
        }
        return `${this.resultsList.length} mapped, ${this.filteredCarParks.length} match filters, ${this.allCarParks.length} Total${amFilterNote}`;
    }
    get isWaiting() {
        return !this.dataLoaded || this.isFiltering;
    }
    get resultsListForDisplay() {
        var alphabeticallySorted = this.resultsList.slice().sort((a, b) => {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0; // a must be equal to b
        }).slice(0, limitCarParksResultsDisplay);
        if (this.selectedMarkerId > 0) { //ensure selected item is NOT in the results and set selectedResult instead
            var selectedItem = Help.singleOrNull(alphabeticallySorted, r => r.id === this.selectedMarkerId);
            if (selectedItem === null) {
                selectedItem = Help.singleOrNull(this.filteredCarParks, r => r.id === this.selectedMarkerId);
            }
            else {
                Help.removeItemFromArray(alphabeticallySorted, selectedItem);
            }
            if (selectedItem !== null) {
                this.selectedResult = selectedItem;
            }
            else {
                this.selectedMarkerId = 0;
            }
            //if (selectedItem !== null) {
            //    alphabeticallySorted.unshift(selectedItem);//adds to start
            //}
            //else {
            //    this.selectedMarkerId = 0;
            //}
        }
        //console.log(`${alphabeticallySorted.length}`)
        return alphabeticallySorted;
    }
    get resultsListForDisplayNotEmpty() {
        return this.selectedMarkerId > 0 ? ((this.resultsListForDisplay.length + 1) > 0) : (this.resultsListForDisplay.length > 0);
    } //maybe just use this.resultsList.length instead which DOES seem to match what's on screen
    get markersCpsIds() {
        return this.filteredCarParksMarkers.map((cpm) => cpm.id);
    }
    get filteredCpsIds() {
        return this.filteredCarParks.map((cpm) => cpm.id);
    }
};
tslib_1.__decorate([
    Watch('currentBounds')
], App.prototype, "onCurrentBoundsChanged", null);
tslib_1.__decorate([
    Watch('filtersSelected')
], App.prototype, "onFiltersSelectedChanged", null);
tslib_1.__decorate([
    Watch('filteredCarParks')
], App.prototype, "onFilteredCarParksChanged", null);
App = tslib_1.__decorate([
    Component({
        components: {
            FilterBtn,
            Result,
            ResultSelected,
            Autocomplete,
            VueDraggableResizable
        }
    })
], App);
export default App;
